import { Link } from "react-router-dom";
import { Icon, Typography } from "@/components/atoms";
import { useLayout, useOperatorAccess } from "@/hooks";
import { clsx } from "@/utils";

/**
 * Full-width red banner shown on every route while the operator's account is inactive
 * (no active/trial subscription). Mirrors PaymentConfigurationBanner's layout and render slot.
 */
export const InactiveAccountBanner = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const { isUnsubscribed, isAdmin } = useOperatorAccess();
  const {
    layout: { sidebarOpen },
  } = useLayout();

  if (!isUnsubscribed || !isAdmin) return null;

  return (
    <div
      className={clsx(
        "relative top-0 z-40 flex min-h-16 flex-col items-center justify-center gap-x-5 bg-danger text-white lg:min-h-10 lg:flex-row lg:pl-[120px]",
        { "lg:pl-[270px]": sidebarOpen },
        className
      )}
      {...props}
    >
      <div className="mx-2 flex flex-row items-center gap-x-2">
        <Icon name="Danger" variant="Bold" size="xs" className="flex-shrink-0" />
        <Typography variant="paragraph">Your account is inactive. Select a plan to continue using RideMinder.</Typography>
      </div>
      <Link to="/payments/subscriptions" className="flex flex-row items-center gap-x-2.5">
        <Typography variant="paragraph" className="underline">
          Subscriptions
        </Typography>
        <Icon name="ArrowRight" size="lg" className="flex-shrink-0" />
      </Link>
    </div>
  );
};
